<template>
  <div>
    <div class="header-group" style="margin-bottom: 20px;">
      <Select v-model="params.CondList[0].Key" @on-change="change_condList">
        <Option
          v-for="(item,index) in d_search_key"
          :value="item.value"
          :key="index"
        >{{ item.label }}</Option>
      </Select>
      <Select
        v-model="params.CondList[0].Operator"
        v-if="params.CondList[0].Key==='b.LastPayDate' || params.CondList[0].Key==='b.Debts'"
      >
        <Option value=">" label="大于"></Option>
        <Option value="<" label="小于"></Option>
      </Select>
      <Select v-model="params.CondList[0].Value" v-if="params.CondList[0].Key==='c.State'">
        <Option v-for="(item,index) in d_State_arr" :value="item" :key="index">{{ item }}</Option>
      </Select>
      <Select v-model="params.CondList[0].Value" v-else-if="params.CondList[0].Key==='b.XiaoXiang'">
        <Option
          v-for="(item,index) in d_XiaoXiangAll_arr"
          :value="item.value"
          :key="index"
        >{{ item.label }}</Option>
      </Select>
      <DatePicker
        type="date"
        placeholder="请选择日期"
        @on-change="change_LastPayDate"
        v-else-if="params.CondList[0].Key==='b.LastPayDate'"
      ></DatePicker>
      <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容" v-else />
      <!--<Button type="text" style="color:#57a3f3" @click="d_modal_search=true">高级筛选</Button>-->
      <Button type="primary" @click="search">查询</Button>
      <div class="right">
        <Button type="primary" @click="to_add" class="margin-right10">新增</Button>
        <Button type="primary" @click="to_export('all')">导出全部</Button>
      </div>
    </div>
    <Table :columns="d_columns" :data="d_data" border></Table>
    <div class="margin-top-20">
      <Page
        :total="d_total"
        show-sizer
        show-total
        @on-change="flip"
        @on-page-size-change="change_size"
        class="pull-right"
      ></Page>
      <div class="clear-both"></div>
    </div>
    <Modal :mask-closable="false" v-model="d_modal_contract" title="选择所属合同" width="800" footer-hide>
      <div class="header-group" style="margin-bottom: 10px;">
        <Select v-model="contract_params.CondList[0].Key" @on-change="change_condList_contract">
          <Option
            v-for="(item,index) in d_search_key_contract"
            :value="item.value"
            :key="index"
          >{{ item.label }}</Option>
        </Select>
        <Input v-model="contract_params.CondList[0].Value" placeholder="请输入搜索内容" />
        <Button type="primary" @click="search_contract()">查询</Button>
      </div>
      <Table
        v-if="d_modal_contract"
        highlight-row
        border
        ref="currentRowTable"
        height="400"
        :columns="d_columns_contract"
        :data="d_data_contract"
        @on-current-change="change_contract"
      ></Table>
    </Modal>
    <Modal
      :mask-closable="false"
      v-model="d_modal_add"
      :title="d_modal_title"
      width="500px"
      footer-hide
    >
      <Form ref="formVl" :model="add_params" :rules="validate" :label-width="120" class>
        <FormItem label="选择合同" prop="ContractID">
          <Button type="primary" shape="circle" icon="ios-add" @click="to_openContract"></Button>
          <span
            v-if="add_params.ContractID!=''"
            class="margin-left10"
          >已选合同：{{ add_params.ContractName || add_params.ContractID }}</span>
        </FormItem>
        <FormItem label="选择科目" prop="XiaoXiang">
          <Col span="12">
            <Select
              v-model="XiaoXiangFather"
              @on-change="change_xiaoxiangFather"
              style="padding-right: 1px;"
            >
              <Option v-for="item in d_XiaoXiangFather_arr" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Col>
          <Col span="12">
            <Select v-model="add_params.XiaoXiang" :disabled="d_XiaoXiang_arr.length>0?false:true">
              <Option
                v-for="item in d_XiaoXiang_arr"
                :value="item.value"
                :key="item.label"
              >{{ item.label }}</Option>
            </Select>
          </Col>
        </FormItem>
        <FormItem label="金额" prop="Money">
          <Input v-model="add_params.Money" style="width: 100px" class="margin-right10"></Input>元
        </FormItem>
        <FormItem label="最后交钱日" prop="LastPayDate">
          <DatePicker
            type="date"
            v-model="add_params.EndDate"
            placeholder="请选择时间"
            @on-change="change_date"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="edit_confirm('formVl')">保存</Button>
          <Button @click="d_modal_add=false" class="margin-left10">取消</Button>
        </FormItem>
      </Form>
    </Modal>
    <!--<Modal-->
    <!--:mask-closable="false"-->
    <!--v-model="d_modal_search">-->
    <!--&lt;!&ndash;<Form :model="params.CondList" :label-width="80">&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;<FormItem label="Input">&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;<Input v-model="formItem.input" placeholder="Enter something..."></Input>&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;</FormItem>&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;</Form>&ndash;&gt;-->
    <!--</Modal>-->
  </div>
</template>
<script>
import apiBill from "@/api/bill.js";
import apiContract from "@/api/contract.js";
export default {
  name: "costManage_page",
  data() {
    return {
      token: "",
      params: {},
      add_params: {},
      d_XiaoXiang_arr: [],
      d_XiaoXiangAll_arr: [],
      d_State_arr: ["待执行", "执行中", "已终止"],
      d_XiaoXiangFather_arr: ["自收类", "代收类"],
      d_modal_search: false,
      d_search_key: [
        {
          label: "合同编号",
          value: "b.ContractID", // && = && input
        },
        {
          label: "来源",
          value: "b.Source", // && = && input
        },
        {
          label: "最后缴纳日",
          value: "b.LastPayDate", // && > && date
        },
        {
          label: "小项",
          value: "b.XiaoXiang", // && = && select
        },
        {
          label: "欠费",
          value: "b.Debts", // && > && input
        },
        {
          label: "合同名称",
          value: "c.Name", // && like && input
        },
        {
          label: "合同状态",
          value: "c.State", // && = && select
        },
      ],
      XiaoXiangFather: "",
      d_modal_add: false,
      d_modal_title: "",
      d_modal_type: "",
      validate: {
        XiaoXiang: [
          { required: true, message: "小项目不能为空", trigger: "change" },
        ],
        UseType: [
          { required: true, message: "请选择收支类型", trigger: "change" },
        ],
        Money: [
          { required: true, message: "金额不能为空", trigger: "blur" },
          {
            type: "string",
            max: 11,
            pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
            message: "金额大于0，只精确到小数点后两位，最多11位",
            trigger: "blur",
          },
        ],
        LastPayDate: [
          { required: true, message: "最后交钱日不能为空", trigger: "blur" },
        ],
      },
      d_columns: [
        {
          title: "大项",
          key: "typeBig",
        },
        {
          title: "小项",
          key: "XiaoXiang",
        },
        {
          title: "所属合同",
          key: "ContractName",
        },
        {
          title: "金额",
          key: "Money",
          render: (h, params) => {
            return h("span", params.row.Money + " 元");
          },
        },
        {
          title: "欠费",
          key: "Debts",
          render: (h, params) => {
            return h("span", params.row.Debts + " 元");
          },
        },
        {
          title: "来源",
          key: "Source",
        },
        {
          title: "状态",
          key: "State",
        },
        {
          title: "最后交钱日",
          key: "LastPayDate",
          render: (h, params) => {
            return h("span", this.to_date(params.row.LastPayDate));
          },
        },
        {
          title: "操作",
          key: "do",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: params.row.State === "待支付" ? false : true,
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.to_edit(params.row);
                    },
                  },
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "提示",
                        content: "<p>您确认要删除该条数据吗？</p>",
                        onOk: () => {
                          this.to_delete(params.row.ID);
                        },
                      });
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      d_data: [],
      loading_export_all: false,
      d_modal_contract: false,
      d_columns_contract: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "合同编号",
          key: "SerialNum",
        },
        {
          title: "合同名称",
          key: "Name",
        },
      ],
      d_data_contract: [],
      d_search_key_contract: [
        {
          value: "c.ID",
          label: "编号",
        },
        {
          value: "c.Name",
          label: "姓名",
        },
        {
          value: "c.Address",
          label: "地址",
        },
      ],
      contract_params: {},
      d_select_contract: {
        ShopIDs: "",
        SerialNum: "",
        Name: "",
      },
      d_total: 0,
    };
  },
  methods: {
    search(){
      this.params.PageIndex = 1;
      this.pull_data();
    },
    flip(page) {
      this.params.PageIndex = page;
      this.pull_data();
    },
    change_size(size) {
      this.params.PageSize = size;
      this.pull_data();
    },
    change_LastPayDate(date) {
      this.params.CondList[0].Value = date;
    },
    change_condList(value) {
      if (value == "c.Name") {
        this.params.CondList[0].Operator = "like";
      } else if (value !== "b.LastPayDate" && value !== "b.Debts") {
        this.params.CondList[0].Operator = "=";
      } else {
        this.params.CondList[0].Operator = ">";
      }
      this.params.CondList[0].Value = "";
    },
    change_date(date) {
      this.add_params.LastPayDate = date;
      this.add_params.BeginDate = date;
      this.add_params.EndDate = date;
    },
    change_xiaoxiangFather(val) {
      let billType = this.$store.state.app.billType;
      if (val === "自收类") {
        this.d_XiaoXiang_arr = billType.selfRent.concat(billType.self2);
      } else {
        this.d_XiaoXiang_arr = billType.instead;
      }
      this.add_params.XiaoXiang = this.d_XiaoXiang_arr[0].value;
    },
    to_openContract() {
      this.d_modal_contract = true;
    },
    change_condList_contract(value) {
      if (value == "c.ID") {
        this.contract_params.CondList[0].Operator = "=";
      } else {
        this.contract_params.CondList[0].Operator = "like";
      }
    },
    search_contract() {
      this.pull_data_contract();
    },
    pull_data_contract() {
      let _this = this;
      apiContract.getList.post(this.contract_params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let RowsList = requestResult.RowsList;
          if (RowsList.length > 0) {
            for (let i = 0; i < RowsList.length; i++) {
              if (this.d_select_contract.SerialNum === RowsList[i].SerialNum) {
                RowsList[i]._highlight = true;
              }
            }
            _this.d_data_contract = RowsList;
          } else {
            // sessionStorage.setItem('contractInfo','');
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    change_contract(currentRow) {
      this.d_modal_contract = false;
      this.add_params.ContractID = currentRow.SerialNum;
      this.add_params.ContractName = currentRow.Name;
      console.log(this.add_params.ContractID);
      console.log(this.add_params.ContractName);
      // let contractInfo = { //前后两个界面都有用到，不要轻易删除
      //   CycleType: currentRow.CycleType,
      //   ShopIDs: currentRow.ShopIDs,
      //   SerialNum: currentRow.SerialNum,
      //   Name: currentRow.Name
      // }
      // sessionStorage.setItem('contractInfo',JSON.stringify(contractInfo));
    },
    //以上为合同相关……
    pull_data() {
      let _this = this;
      if (this.params.CondList[0].Key === "c.Name") {
        sessionStorage.setItem("cName", this.params.CondList[0].Value);
      }
      apiBill.getList.post(this.params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let rowsList = requestResult.RowsList;
          this.d_total = requestResult.Total;
          let billType = this.$store.state.app.billType;
          let typeSelf = billType.selfRent
            .concat(billType.self2)
            .map((item) => item.value);
          let typeAgent = billType.instead.map((item) => item.value);
          for (let item of rowsList) {
            if (typeSelf.indexOf(item.XiaoXiang) > -1) {
              item.typeBig = "自收类";
            }
            if (typeAgent.indexOf(item.XiaoXiang) > -1) {
              item.typeBig = "代收类";
            }
          }
          _this.d_data = rowsList;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_date(date) {
      let moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    edit_confirm(name) {
      if (
        this.add_params.ContractID === "" ||
        this.add_params.ContractID === null
      ) {
        this.$Message.error("请选择合同id");
        return;
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.submit_edit_data();
        } else {
          this.$Message.error("验证失败!");
        }
      });
    },
    submit_edit_data() {
      this.add_params.ShopIDs = this.d_select_contract.ShopIDs;
      this.add_params.Source = "手动添加";
      if (this.d_modal_type === "add") {
        apiBill.add.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.pull_data();
            this.d_modal_add = false;
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      } else {
        apiBill.edit.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.pull_data();
            this.d_modal_add = false;
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      }
    },
    to_add() {
      this.d_modal_type = "add";
      this.d_modal_title = "添加账单";
      this.d_modal_add = true;
      this.$refs.formVl.resetFields();
      this.XiaoXiangFather = "";
      this.add_params = JSON.parse(JSON.stringify(apiBill.add.data)); //还原账单数组
    },
    to_edit(_row) {
      this.d_modal_type = "edit";
      this.d_modal_title = "账单修改";
      this.d_modal_add = true;
      this.add_params = _row;
      this.add_params.Money = _row.Money + "";
      let billType = this.$store.state.app.billType;
      let billTypeSelf = billType.selfRent
        .concat(billType.self2)
        .map((item) => item.value);
      let billTypeInstead = billType.instead.map((item) => item.value);
      if (billTypeSelf.indexOf(this.add_params.XiaoXiang) > -1) {
        this.XiaoXiangFather = "自收类";
        this.d_XiaoXiang_arr = billType.selfRent.concat(billType.self2);
      }
      if (billTypeInstead.indexOf(this.add_params.XiaoXiang) > -1) {
        this.XiaoXiangFather = "代收类";
        this.d_XiaoXiang_arr = billType.instead;
      }
    },
    to_delete(_idList) {
      apiBill.del(_idList).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.$Message.success("删除成功");
          this.pull_data();
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_export(_type) {
      let _this = this;
      this.params.PageIndex = 1;
      this.params.PageSize = 10000000;
      this.loading_export_all = true;
      apiBill.export.post(this.params).then((_data) => {
        console.log(_data);
        if (_data.data) {
          setTimeout(function () {
            _this.loading_export_all = false;
          }, 1000);
          let blob = _data.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function (e) {
            let a = document.createElement("a");
            a.download = "账单列表.xlsx";
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        } else {
          this.$Message.error("导出报表出错");
        }
      });
    },
  },
  created() {
    let billType = this.$store.state.app.billType;
    this.d_XiaoXiangAll_arr = billType.selfRent.concat(
      billType.self2,
      billType.instead
    );
    this.params = JSON.parse(JSON.stringify(apiBill.getList.data));
    this.params.CondList[0].Key = "c.Name";
    this.params.CondList[0].Operator = "like";
    this.params.CondList[0].Value = sessionStorage.getItem("cName") || "";
    this.add_params = JSON.parse(JSON.stringify(apiBill.add.data)); //新增账单
    this.contract_params = JSON.parse(JSON.stringify(apiContract.getList.data)); //选择合同
    this.pull_data_contract();
    // let contractInfo = sessionStorage.getItem('contractInfo');
    // if(contractInfo){
    //   this.d_select_contract = JSON.parse(contractInfo);
    // }
    this.pull_data();
  },
  mounted() {

    this.token = sessionStorage.getItem("token");
    this.contract_params.PageIndex = 1;
    this.contract_params.PageSize = 100;
  },
};
</script>
<style scoped>
@import "../../../assets/css/table-list.css";
.form-title {
  line-height: 40px;
  text-indent: 10px;
  background-color: #f3f3f3;
  margin-bottom: 10px;
}
.margin-right10 {
  margin-right: 10px;
}
.cost-form-group {
  border: solid 1px #e8eaec;
  padding: 20px 0;
}
h4.title {
  font-size: 14px;
  font-weight: normal;
  color: #5c5c5c;
}
.header-group {
  margin-bottom: 40px;
}
</style>
<style>
.ivu-form-item-content {
  line-height: 33px;
}
</style>










